import { retrieveJsonRequest } from "./utils";

export default function getAccountData() {
    return retrieveJsonRequest(`/core/account/data`);
}
